import {React} from "../../../../../vendor";
import FormItem from "../../../components/FormItem";
import t from "../../../helpers/t";
import {useSelector, awsActions} from "inbooma-api";
import {useEffect, useState} from "react";
import {showNotification} from "../../tasks";
import {Biscuit} from "../../../../utils";

const Tools = (props) =>
{
    const _awsData = useSelector(state => state.aws_data.awsData);
    const {dispatch} = props;
    const [awsData, setAwsData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState('');

    useEffect(()=> {
        if(awsData !== null || loading === true) return;
        dispatch(awsActions.awsData({
            token: Biscuit.get('token'),
            data: {
                "action": "describe",
                "type": "rds"
            }
        }));
        setLoading(true);
    },[]);

    useEffect(()=> {
        if(_awsData.success === '' || !loading) return;
        if(_awsData.success === true) {
            if(typeof _awsData.data['ib2live'] !== 'undefined') {
                setAwsData(_awsData.data);
            } else {
                showNotification('success', null, t('${a} successfully restarted',{a:t(type)}));
            }
        } else {
            showNotification('warning',null, _awsData.data.message);
        }
        setLoading(false);
    }, [_awsData]);

    const restartTestRDS = () => {
        setType('test rds');
        awsActions.awsData({
            token: Biscuit.get('token'),
            data: {
                "action": "restartTest",
                "type": 'rds'
            }
        });
        setLoading(true)
    }

    const restartLiveRDS = () => {
        setType('live rds');
        awsActions.awsData({
            token: Biscuit.get('token'),
            data: {
                "action": "restartLive",
                "type": 'rds'
            }
        });
        setLoading(true)
    }

    const restartTestEC2 = () => {
        setType('test ec2');
        awsActions.awsData({
            token: Biscuit.get('token'),
            data: {
                "action": "restartTest",
                "type": 'ec2'
            }
        });
        setLoading(true)
    }

    const restartLiveEC2 = () => {
        setType('live ec2');
        awsActions.awsData({
            token: Biscuit.get('token'),
            data: {
                "action": "restartLive",
                "type": 'ec2'
            }
        });
        setLoading(true)
    }


    return (
        <>
            <div className="row">
        <FormItem
            type="button"
            link="/visual_inspections"
            name="visual_inspections"
            label={t('visual_inspections')}
            icon=""
            beautify={true}
            round={true}
            mediumWidth={3}
            smallWidth={6}
            extraTopClasses=""/>
            <FormItem
                type="button"
                link="/client_docs"
                name="client_documents"
                label={t('client_documents')}
                icon=""
                beautify={true}
                round={true}
                mediumWidth={3}
                smallWidth={6}
                extraTopClasses=""/>
                <FormItem
                    type="button"
                    link="/help_messages"
                    name="help_messages"
                    label={t('help messages')}
                    icon=""
                    beautify={true}
                    round={true}
                    mediumWidth={3}
                    smallWidth={6}
                    extraTopClasses=""/>
            </div>
            {awsData !== null && !loading &&<><hr className="column large-12 medium-12 small-12"/>
                <div className="row">
            <label className="column large-12 medium-12 small-12">{t('aws_rds_instances')}</label>
                {Object.keys(awsData).map(index => {
                    return (
                        <>
                            <div className="column large-6 medium-6 small-12">
                                <label>Status {index}</label><br/>
                                <span>{awsData[index]['Current Status']}</span>
                            </div>
                        </>
                    )
                })}
                </div>
            </>}
<div className="row">
            <FormItem
                type="button"
                link="#"
                name="restart_test_rds"
                label={t('Restart ${a}',{a:t('test rds')})}
                icon=""
                onChangeHandler={restartTestRDS}
                beautify={true}
                round={true}
                mediumWidth={3}
                smallWidth={6}
                extraTopClasses=""/>
            <FormItem
                type="button"
                link="#"
                name="restart_live_rds"
                label={t('Restart ${a}',{a:t('live rds')})}
                icon=""
                onChangeHandler={restartLiveRDS}
                beautify={true}
                round={true}
                mediumWidth={3}
                smallWidth={6}
                extraTopClasses=""/>
            <FormItem
                type="button"
                link="#"
                name="restart_test_ec2"
                label={t('Restart ${a}',{a:t('test ec2')})}
                icon=""
                onChangeHandler={restartTestEC2}
                beautify={true}
                round={true}
                mediumWidth={3}
                smallWidth={6}
                extraTopClasses=""/>
            <FormItem
                type="button"
                link="#"
                name="restart_live_ec2"
                label={t('Restart ${a}',{a:t('live ec2')})}
                icon=""
                onChangeHandler={restartLiveEC2}
                beautify={true}
                round={true}
                mediumWidth={3}
                smallWidth={6}
                extraTopClasses=""/>
</div>
        </>


                );
}
export default Tools;